import clickOutside from './click-outside'

const importDirective = Vue => {
  Vue.directive('click-outside', clickOutside)
}

export default importDirective



// WEBPACK FOOTER //
// ./src/utils/directives/index.js